// Remove expired data from Local Storage

export const getItemFromLocalStorageWithExpiry = (key: string) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
        const item = JSON.parse(itemStr);
        if (!item?.expiry) {
            localStorage.removeItem(key);
            return null;
        }

        if (Date.now() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    } catch {
        return itemStr
    }
};